<div class="h-2/5 grid sm:max-md:grid-flow-row sm:max-md:grid-rows-3 place-items-center md:grid-flow-col md:grid-cols-3 my-8">
    <div class="page-links">
        <ul class="text-base grid grid-flow-col grid-cols-3">
            <li><a routerLink="/">Home</a></li>
            <li><a routerLink="/rooms">Rooms</a></li>
            <li><a routerLink="/contact">Contact</a></li>
        </ul>
    </div>
    <div class="w-48"><img src="footer-logo.webp" /></div>
    <div class="">Copyright © {{ year }}</div>
</div>
